// extracted by mini-css-extract-plugin
module.exports = {"row":"form_row__58ipV","footer":"form_footer__tBZ2t","ready_title":"form_ready_title__1eVL9"};